import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Alert, Box, Button, Link, TextField, Typography } from '@mui/material';
import * as authenticateActions from '../../actions/authenticateActions';
import { notify } from '../../util/notifications';
import { landingRoute } from '../../util/landingRoute';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

class MfaLogin extends Component {
    state = { email: '', otp: '', showOtpForm: false, isLoading: false, errorMessage: '', submitted: false };

    fail = (message) => {
        this.setState({ isLoading: false, errorMessage: message });
        notify.createNotification('error', message, this.props.refNotify);
    };

    sendCode = (email) => {
        const { dispatch } = this.props;
        this.setState({ isLoading: true, errorMessage: '' });
        dispatch(
            authenticateActions.checkEmailDomain(
                email,
                () => {
                    dispatch(
                        authenticateActions.generateOtp(
                            email,
                            () => {
                                this.setState({ isLoading: false, showOtpForm: true, email, submitted: false });
                                notify.createNotification('success', `Code sent to ${email}`, this.props.refNotify);
                            },
                            (otpFail) => this.fail((otpFail && otpFail.statusMsg) || "The code couldn't be sent. Try again.")
                        )
                    );
                },
                (fail) =>
                    this.fail((fail && fail.statusMsg) || "This email's domain isn't set up for code sign-in.")
            )
        );
    };

    handleEmailSubmit = (event) => {
        event.preventDefault();
        this.setState({ submitted: true });
        const email = this.state.email.trim();
        if (!EMAIL_PATTERN.test(email)) return;
        this.sendCode(email);
    };

    handleOtpSubmit = (event) => {
        event.preventDefault();
        this.setState({ submitted: true });
        const { otp, email } = this.state;
        if (!/^\d{6}$/.test(otp)) return;
        const { dispatch, history } = this.props;
        this.setState({ isLoading: true, errorMessage: '' });
        dispatch(
            authenticateActions.verifyOtp(
                email,
                otp,
                () => {
                    this.setState({ isLoading: false });
                    history.push(landingRoute());
                },
                (fail) => this.fail((fail && fail.statusMsg) || "That code didn't match. Check it and try again.")
            )
        );
    };

    render() {
        const { email, otp, showOtpForm, isLoading, errorMessage, submitted } = this.state;

        if (!showOtpForm) {
            const emailError = submitted && !EMAIL_PATTERN.test(email.trim()) ? 'Enter a valid email address' : '';
            return (
                <Box component="form" noValidate onSubmit={this.handleEmailSubmit} sx={{ display: 'grid', gap: 2 }}>
                    <TextField
                        label="Work email"
                        type="email"
                        autoComplete="email"
                        autoFocus
                        size="medium"
                        value={email}
                        onChange={(e) => this.setState({ email: e.target.value })}
                        disabled={isLoading}
                        error={Boolean(emailError)}
                        helperText={emailError}
                    />
                    {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
                    <Button type="submit" variant="contained" size="large" disabled={isLoading}>
                        {isLoading ? 'Sending code…' : 'Send code'}
                    </Button>
                    <Button variant="text" onClick={this.props.onSwitchLoginMode}>
                        Sign in with a password instead
                    </Button>
                </Box>
            );
        }

        const otpError = submitted && !/^\d{6}$/.test(otp) ? 'Enter the 6-digit code' : '';
        return (
            <Box component="form" noValidate onSubmit={this.handleOtpSubmit} sx={{ display: 'grid', gap: 2 }}>
                <Typography color="text.secondary">
                    Enter the code we sent to <strong>{email}</strong>.
                </Typography>
                <TextField
                    label="6-digit code"
                    autoComplete="one-time-code"
                    autoFocus
                    size="medium"
                    value={otp}
                    onChange={(e) => this.setState({ otp: e.target.value.replace(/\D/g, '').slice(0, 6) })}
                    disabled={isLoading}
                    error={Boolean(otpError)}
                    helperText={otpError}
                    inputProps={{ inputMode: 'numeric', maxLength: 6, style: { letterSpacing: 6, fontSize: 18 } }}
                />
                {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
                <Button type="submit" variant="contained" size="large" disabled={isLoading}>
                    {isLoading ? 'Checking…' : 'Verify and sign in'}
                </Button>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Link
                        component="button"
                        type="button"
                        underline="hover"
                        onClick={() => this.setState({ showOtpForm: false, otp: '', errorMessage: '', submitted: false })}
                    >
                        Use a different email
                    </Link>
                    <Link component="button" type="button" underline="hover" disabled={isLoading} onClick={() => this.sendCode(email)}>
                        Resend code
                    </Link>
                </Box>
            </Box>
        );
    }
}

const mapStateToProps = (state) => ({
    authInfo: state.authInfo,
    refNotify: state.refNotify,
});

export default withRouter(connect(mapStateToProps)(MfaLogin));
